/**
 * Horizontal scrollable route options - Google Maps style
 */
function RouteOptionsCard({ routes, selectedIndex, onSelectRoute }) {
  if (!routes || routes.length <= 1) return null;

  return (
    <div className="px-4 py-2">
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-hide">
        {routes.map((route, index) => (
          <button
            key={index}
            onClick={() => onSelectRoute(index)}
            className={`
              flex-shrink-0 px-4 py-2.5 rounded-xl border-2 transition-all
              ${index === selectedIndex
                ? 'bg-blue-600 text-white border-blue-600 shadow-lg'
                : 'bg-white text-gray-700 border-gray-200 shadow-sm hover:border-gray-300'}
            `}
          >
            <div className={`text-base font-semibold ${index === selectedIndex ? 'text-white' : 'text-gray-900'}`}>
              {route.duration?.text || '...'}
            </div>
            <div className={`text-xs ${index === selectedIndex ? 'text-blue-100' : 'text-gray-500'}`}>
              {route.distance?.text || ''}
            </div>
            {route.summary && (
              <div className={`text-xs mt-0.5 truncate max-w-[100px] ${index === selectedIndex ? 'text-blue-200' : 'text-gray-400'}`}>
                via {route.summary}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default RouteOptionsCard;
